const toUSD = (
  amount: number,
  options?: Omit<Intl.NumberFormatOptions, "style" | "currency">
): string => {
  const defaultOptions: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  return amount.toLocaleString("en-US", {
    ...defaultOptions,
    ...options,
  });
};

export default toUSD;
